import { Crud } from '../common/Edit';
import { ApproveRequestPageType } from 'pages/approves/ApproveRequestDetailCase';

/**
 * 셋업일정요청유형
 *
 * [25.10.28] 일정등록(설비추가) 유형은 현재 미사용
 * APR_REQ_PAGE_TP_CD.{SETUP_SCHD_REG | SETUP_SCHD_CHG}
 * 코드명을 검색조건, 목록 등 화면에서 사용하고,
 * 옵션값1의 결재양식ID를 검색조건으로 사용한다.
 */
export const SetupScheduleReqTypes = [
  ApproveRequestPageType.SETUP_SCHD_REG, // 일정등록
  ApproveRequestPageType.SETUP_SCHD_CHG, // 일정변경
] as string[];

export interface SetupScheduleCondition {
  bildPlntCds?: any; // 플랜트코드
  elmPrjId?: string; // 프로젝트ID
  excpId?: string; // 협력사ID
  // excpNm?: string; // 협력사명
  aprTplIds?: any; // 결재양식ID (=요청유형)
  delayYn?: string; // 지연여부
  changeYn?: string; // 변경여부
  wkId?: string; // 작업ID
}

export interface SetupSchedule extends Crud {
  elmPrjId?: string; // ELM프로젝트ID
  elmPrjNm?: string; // ELM프로젝트명
  bildPlntCd?: string; // 건설플랜트코드
  bildPlntCdNm?: string; // 건설플랜트명
  planReqId?: string; // Down ID
  excpId?: string; // 협력사ID
  excpNm?: string; // 협력사명
  excpAbbrNm?: string; // 협력사약어(3자리)

  wkProgStatCd?: string; // 작업진행상태코드
  wkProgStatCdNm?: string; // 작업진행상태코드명
  aprReqProgStatCd?: string; // 결재요청진행상태코드
  aprReqProgStatCdNm?: string; // 결재요청진행상태코드명

  aprTplId?: string; // 결재양식ID (=요청유형)
  aprTplNm?: string; // 요청유형 (=결재양식명)
  aprReqId?: string; // 결재요청ID

  aprAprvUserId?: string; // 결재자ID
  aprAprvUserNm?: string; // 결재자명
  aprAprvDtm?: string; // 결재일시

  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값명1
  optValCtn2?: string; // 옵션값명2
  optValCtn3?: string; // 옵션값명3
  optValCtn4?: string; // 옵션값명4
  optValCtn5?: string; // 옵션값명5

  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsUserIp?: string;
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터수정사용자명
  dataUpdUserIp?: string;
  dataUpdDtm?: string; // 데이터수정일시
  aprReqTpCd?: string; // 결재요청유형
  readOnlyYn?: string;
}

export interface SetupTargetStepSchedule extends Crud {
  tgtEqpId?: string; // 대상설비ID
  spTpCd?: string; // 단계유형코드
  prjSpCd?: string; // 프로젝트단계코드
  elmPrjId?: string; // 프로젝트ID
  excpId?: string; // 협력사ID
  eqpId?: string; // 설비ID
  planStDt?: string; // 계획시작일자
  planEndDt?: string; // 계획종료일자
  wkProgStatCd?: string; // 작업진행상태코드
  wkProgStatCdNm?: string; // 작업진행상태코드명
  atulStDt?: string; // 실제시작일자
  atulEndDt?: string; // 실제종료일자
  progRt?: string; // 진행비율
  cmnYn?: string; // 공통여부
  cpltYn?: string; // 완료여부
  isptDt?: string; // 점검일자
  isptCtn?: string; // 점검내용
  isptUserId?: string; // 점검사용자ID
  planProcId?: string; // 계획공정ID
  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값명1
  optValCtn2?: string; // 옵션값명2
  optValCtn3?: string; // 옵션값명3
  optValCtn4?: string; // 옵션값명4
  optValCtn5?: string; // 옵션값명5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsUserIp?: string;
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터수정사용자명
  dataUpdUserIp?: string;
  dataUpdDtm?: string; // 데이터수정일시
}

export interface SetupTargetStepScheduleRequest extends SetupTargetStepSchedule {
  aprReqId: string;
  aprReqTpCd?: string;
  newPlanStDt?: string;
  newPlanEndDt?: string;
  chgRsnCtn?: string;
  eqpNm?: string;
  excpNm?: string;
  aprProgStatCd?: string;
  aprProgStatCdNm?: string;
  aplCpltYn?: string;
  aprReqUserId?: string;
  aprReqUserNm?: string;
  aprAprvUserId?: string;
  aprAprvUserNm?: string;
  prjSpCdNm?: string;
  requestList?: SetupTargetStepScheduleRequest[];
}
